import React from 'react';

interface UserIconProps {
  className?: string;
  size?: number;
  color?: string;
}

// User profile: a head-and-shoulders mark, stroked in the same style as the
// other sidebar nav icons.
const UserIcon: React.FC<UserIconProps> = ({ className, size = 24, color = 'currentColor' }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="8" r="4" stroke={color} strokeWidth="1.6" />
    <path
      d="M4 20C4 16.6863 7.58172 14 12 14C16.4183 14 20 16.6863 20 20"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export default UserIcon;
